import React, { useState } from "react";
import styles from "./RatingStars.module.scss";

const DefaultStar = ({ filled }) => (
  <svg
    width="24"
    height="22"
    viewBox="0 0 24 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.59 22L6.54 13.8658L0 8.39474L8.64 7.67105L12 0L15.36 7.67105L24 8.39474L17.46 13.8658L19.41 22L12 17.6868L4.59 22Z"
      fill={filled ? "#F8C500" : "#D2D7DF"}
    />
  </svg>
);

export const OutlineStar = ({ filled, fillPercentage = 1 }) => {
  const clampedFill = Math.max(0, Math.min(fillPercentage, 1)); // Ensure the value is between 0 and 1
  const fillWidth = clampedFill * 100; // Convert to percentage for the gradient

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient
          id={`starFill-${fillWidth}`}
          x1="100%"
          y1="0%"
          x2="0%"
          y2="0%"
        >
          <stop
            offset={`${100 - fillWidth}%`}
            stopColor={filled ? "#F8C500" : "white"}
          />
          <stop
            offset={`${100 - fillWidth}%`}
            stopColor={filled ? "white" : "white"}
          />
        </linearGradient>
      </defs>
      <path
        d="M9.99984 0C10.4262 0 10.8084 0.265561 10.976 0.674491L13.2609 6.247L19.0318 6.795C19.4581 6.83673 19.8179 7.13571 19.9486 7.55821C20.0819 7.98171 19.9486 8.44348 19.6352 8.73634L15.2743 12.7266L16.5597 18.64C16.6564 19.074 16.493 19.5233 16.1463 19.7848C15.7996 20.0456 15.3423 20.0651 14.9777 19.8408L10.0023 16.736L5.02243 19.8408C4.85576 19.9458 4.66254 20 4.47554 20C4.25553 20 4.04214 19.9287 3.8558 19.7886C3.50912 19.5278 3.34896 19.0786 3.44197 18.6438L4.72782 12.7306L0.36242 8.74016C0.0284072 8.44806 -0.0773268 7.98445 0.0560117 7.56203C0.18935 7.13978 0.54271 6.83975 0.968726 6.79882L6.7441 6.25082L9.02771 0.678524C9.19439 0.268793 9.58097 0.00382028 10.0043 0.00382028L9.99984 0Z"
        fill={
          filled && clampedFill === 1
            ? "#F8C500"
            : `url(#starFill-${fillWidth})`
        }
        stroke={filled && clampedFill === 1 ? "none" : "#E1E6EB"}
        strokeWidth={filled && clampedFill === 1 ? 0 : 1}
        strokeLinejoin="round"
      />
    </svg>
  );
};

const RatingStars = ({
  onChange,
  name,
  defaultValue,
  value: rating,
  hideLabel,
  starComponent,
  isStatic = false,
}) => {
  const [hover, setHover] = useState(0);

  const labels = {
    1: "ردئ",
    2: "أقل من المتوسط",
    3: "متوسط",
    4: "جيد",
    5: "ممتاز",
  };

  const handleClick = (value) => {
    // setRating(value);
    onChange?.(value);
  };

  const StarComponent = starComponent || DefaultStar;

  return (
    <div
      className={styles.ratingContainer}
      style={{ ...(hideLabel && { paddingBottom: 0 }) }}
    >
      <div className={styles.stars}>
        {[...Array(5)].map((_, index) => {
          const fillPercentage = Math.max(0, Math.min(1, rating - index));
          return (
            <button
              key={`${name}-${index + 1}`}
              type="button"
              className={styles.starButton}
              onClick={() => !isStatic && handleClick(index + 1)}
              onMouseEnter={() => !isStatic && setHover(index + 1)}
              onMouseLeave={() => !isStatic && setHover(0)}
            >
              <StarComponent
                filled={index < (hover || rating)}
                fillPercentage={fillPercentage}
              />
            </button>
          );
        })}
      </div>
      {(hover || rating) > 0 && !hideLabel && (
        <div className={styles.label}>{labels[hover || rating]}</div>
      )}
    </div>
  );
};

export default RatingStars;
